import type { I18nFn } from '#/i18n/types/I18nFn';

import { LISTING_TYPE_HUMAN_NAME_MAP } from './listingTypeHumanNameMap';
import {
  LISTING_TYPE_PLURAL_HUMAN_NAME_MAP,
  LISTING_TYPE_PLURAL_HUMAN_TRACKING_NAME_MAP,
} from './listingTypePluralHumanNameMap';

export function SAVED_ITEM_TYPE_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    ...LISTING_TYPE_HUMAN_NAME_MAP(i18n),
    SEARCH: i18n('searches'),
  };
}

export function SAVED_ITEM_TYPE_PLURAL_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    ...LISTING_TYPE_PLURAL_HUMAN_NAME_MAP(i18n),
    SEARCH: i18n('searches'),
  };
}

export const SAVED_ITEM_TYPE_PLURAL_HUMAN_TRACKING_NAME_MAP = {
  ...LISTING_TYPE_PLURAL_HUMAN_TRACKING_NAME_MAP,
  SEARCH: 'searches',
};
